import { withStyles } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';

const FlagMessageCopy = withStyles({
    tooltip: {
        color: '#1DA578',
        backgroundColor: '#D7F4E2',
        padding: '8px 16px',
        marginBottom: '2rem',
        fontSize: '14px',
        boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
    },  
    arrow: {
        color: '#D7F4E2'
    }
})(Tooltip);

export default FlagMessageCopy;
